import request from '../request'

//兑换优惠券
export const getCampusOfferDetail = (token)=>{
	return request({
		url: `/v4/comp_recruit_infos/${ token }`,
		method: 'GET'
	})
}
